import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`hr_departments\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`parent_id\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`dept_company_idx\` ON \`hr_departments\` (\`company_id\`,\`is_active\`);
CREATE TABLE IF NOT EXISTS \`hr_designations\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`desg_company_idx\` ON \`hr_designations\` (\`company_id\`,\`is_active\`);
CREATE TABLE IF NOT EXISTS \`hr_salary_structures\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`description\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`ss_company_idx\` ON \`hr_salary_structures\` (\`company_id\`,\`is_active\`);
CREATE TABLE IF NOT EXISTS \`hr_employees\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`employee_code\` text NOT NULL,
	\`first_name\` text NOT NULL,
	\`last_name\` text NOT NULL,
	\`nickname\` text,
	\`id_card_number\` text,
	\`date_of_birth\` text,
	\`gender\` text,
	\`nationality\` text,
	\`phone\` text,
	\`email\` text,
	\`address\` text,
	\`emergency_contact\` text,
	\`department_id\` text,
	\`designation_id\` text,
	\`employment_type\` text DEFAULT 'full_time' NOT NULL,
	\`join_date\` text,
	\`confirm_date\` text,
	\`resign_date\` text,
	\`bank_account_no\` text,
	\`bank_code\` text,
	\`social_security_no\` text,
	\`tax_id\` text,
	\`salary\` integer,
	\`salary_structure_id\` text,
	\`user_id\` text,
	\`status\` text DEFAULT 'active' NOT NULL,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`branch_id\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`emp_company_idx\` ON \`hr_employees\` (\`company_id\`,\`is_active\`);
CREATE INDEX IF NOT EXISTS \`emp_department_idx\` ON \`hr_employees\` (\`company_id\`,\`department_id\`);
CREATE INDEX IF NOT EXISTS \`emp_code_idx\` ON \`hr_employees\` (\`company_id\`,\`employee_code\`);
CREATE TABLE IF NOT EXISTS \`hr_holidays\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`date\` text NOT NULL,
	\`is_optional\` integer DEFAULT 0 NOT NULL,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`hol_company_date_idx\` ON \`hr_holidays\` (\`company_id\`,\`date\`);
CREATE TABLE IF NOT EXISTS \`hr_leave_types\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`max_days_per_year\` integer DEFAULT 0 NOT NULL,
	\`is_paid\` integer DEFAULT 1 NOT NULL,
	\`requires_approval\` integer DEFAULT 1 NOT NULL,
	\`allow_carry_forward\` integer DEFAULT 0 NOT NULL,
	\`max_carry_forward_days\` integer DEFAULT 0 NOT NULL,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`lt_company_idx\` ON \`hr_leave_types\` (\`company_id\`,\`is_active\`);
CREATE TABLE IF NOT EXISTS \`hr_leave_allocations\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`employee_id\` text NOT NULL,
	\`leave_type_id\` text NOT NULL,
	\`fiscal_year\` text NOT NULL,
	\`total_allocated\` real DEFAULT 0 NOT NULL,
	\`used\` real DEFAULT 0 NOT NULL,
	\`balance\` real DEFAULT 0 NOT NULL,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`lal_company_employee_idx\` ON \`hr_leave_allocations\` (\`company_id\`,\`employee_id\`,\`fiscal_year\`);
CREATE INDEX IF NOT EXISTS \`lal_leave_type_idx\` ON \`hr_leave_allocations\` (\`company_id\`,\`leave_type_id\`,\`fiscal_year\`);
CREATE TABLE IF NOT EXISTS \`hr_leave_applications\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`application_no\` text NOT NULL,
	\`employee_id\` text NOT NULL,
	\`leave_type_id\` text NOT NULL,
	\`from_date\` text NOT NULL,
	\`to_date\` text NOT NULL,
	\`total_days\` real NOT NULL,
	\`reason\` text,
	\`status\` text DEFAULT 'draft' NOT NULL,
	\`approved_by\` text,
	\`approved_at\` text,
	\`rejection_reason\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`la_company_idx\` ON \`hr_leave_applications\` (\`company_id\`,\`status\`);
CREATE INDEX IF NOT EXISTS \`la_employee_idx\` ON \`hr_leave_applications\` (\`company_id\`,\`employee_id\`);
CREATE INDEX IF NOT EXISTS \`la_date_idx\` ON \`hr_leave_applications\` (\`company_id\`,\`from_date\`,\`to_date\`);
CREATE TABLE IF NOT EXISTS \`hr_attendance\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`employee_id\` text NOT NULL,
	\`date\` text,
	\`check_in_datetime\` text,
	\`check_out_datetime\` text,
	\`working_hours\` real DEFAULT 0 NOT NULL,
	\`status\` text DEFAULT 'present' NOT NULL,
	\`overtime_hours\` real DEFAULT 0 NOT NULL,
	\`late_minutes\` integer DEFAULT 0 NOT NULL,
	\`remarks\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`att_company_date_idx\` ON \`hr_attendance\` (\`company_id\`,\`date\`);
CREATE INDEX IF NOT EXISTS \`att_employee_idx\` ON \`hr_attendance\` (\`company_id\`,\`employee_id\`,\`date\`);
CREATE TABLE IF NOT EXISTS \`hr_overtime_requests\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`employee_id\` text NOT NULL,
	\`date\` text NOT NULL,
	\`hours\` real NOT NULL,
	\`reason\` text,
	\`ot_type\` text DEFAULT 'weekday' NOT NULL,
	\`ot_rate\` real DEFAULT 1.5 NOT NULL,
	\`status\` text DEFAULT 'pending' NOT NULL,
	\`approved_by\` text,
	\`approved_at\` text,
	\`rejection_reason\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`ot_company_idx\` ON \`hr_overtime_requests\` (\`company_id\`,\`status\`);
CREATE INDEX IF NOT EXISTS \`ot_employee_idx\` ON \`hr_overtime_requests\` (\`company_id\`,\`employee_id\`);
CREATE TABLE IF NOT EXISTS \`hr_payroll_entries\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`payroll_no\` text NOT NULL,
	\`payroll_month\` text NOT NULL,
	\`status\` text DEFAULT 'draft' NOT NULL,
	\`total_employees\` integer DEFAULT 0 NOT NULL,
	\`total_earnings\` real DEFAULT 0 NOT NULL,
	\`total_deductions\` real DEFAULT 0 NOT NULL,
	\`total_net_pay\` real DEFAULT 0 NOT NULL,
	\`payment_date\` text,
	\`payment_method\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`pe_company_month_idx\` ON \`hr_payroll_entries\` (\`company_id\`,\`payroll_month\`);
CREATE INDEX IF NOT EXISTS \`pe_status_idx\` ON \`hr_payroll_entries\` (\`company_id\`,\`status\`);
CREATE TABLE IF NOT EXISTS \`hr_salary_components\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`salary_structure_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`type\` text NOT NULL,
	\`calculation_type\` text DEFAULT 'fixed' NOT NULL,
	\`amount\` real DEFAULT 0 NOT NULL,
	\`percentage\` real,
	\`is_taxable\` integer DEFAULT 1 NOT NULL,
	\`is_statutory\` integer DEFAULT 0 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`sc_structure_idx\` ON \`hr_salary_components\` (\`salary_structure_id\`);
CREATE INDEX IF NOT EXISTS \`sc_company_idx\` ON \`hr_salary_components\` (\`company_id\`);
CREATE TABLE IF NOT EXISTS \`hr_salary_slips\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`slip_no\` text NOT NULL,
	\`payroll_entry_id\` text NOT NULL,
	\`employee_id\` text NOT NULL,
	\`employee_code\` text,
	\`employee_name\` text,
	\`department_id\` text,
	\`designation_id\` text,
	\`base_salary\` real DEFAULT 0 NOT NULL,
	\`total_earnings\` real DEFAULT 0 NOT NULL,
	\`total_deductions\` real DEFAULT 0 NOT NULL,
	\`net_pay\` real DEFAULT 0 NOT NULL,
	\`income_tax\` real DEFAULT 0 NOT NULL,
	\`social_security\` real DEFAULT 0 NOT NULL,
	\`provident_fund\` real DEFAULT 0 NOT NULL,
	\`earnings_detail\` text,
	\`deductions_detail\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_by\` text,
	\`updated_at\` text NOT NULL,
	\`deleted_by\` text,
	\`deleted_at\` text
);
CREATE INDEX IF NOT EXISTS \`sslip_payroll_idx\` ON \`hr_salary_slips\` (\`payroll_entry_id\`);
CREATE INDEX IF NOT EXISTS \`sslip_employee_idx\` ON \`hr_salary_slips\` (\`company_id\`,\`employee_id\`);
CREATE INDEX IF NOT EXISTS \`sslip_company_idx\` ON \`hr_salary_slips\` (\`company_id\`);
  `.trim(),
};
